import { FilterIcon } from "assets/icons";
import { If } from "components";
import { convertSearchParamsToObject } from "helpers";
import { useOnClickOutside } from "hooks";
import { useRef } from "react";
/* eslint-disable react-hooks/exhaustive-deps */
import { createSearchParams, useSearchParams } from "react-router-dom";
import { Button } from "ui";

import { ORDER_FILTER_SEARCH_PARAMETERS } from "../../constants";
import { getOrdersTableFilterNewSearchParams } from "../../helpers";
import { FilterFormValues, OrdersFilterForm } from "../forms";
import { OrdersTableFilterProps } from "./OrdersTableFilter.types";

import styles from "./OrdersTableFilter.module.scss";

const ORDERS_FILTER_FORM_ID = "orders-filter-form-id";

const OrdersTableFilter = ({
  isLoading,
  isOpen,
  onClose,
  onToggle,
  drivers,
  isDriversLoading,
  locations,
  isLocationsLoading
}: OrdersTableFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const containerRef = useRef(null);
  useOnClickOutside(containerRef, onClose);

  const submitFilterForm = (body: FilterFormValues) => {
    const existingParams = convertSearchParamsToObject(searchParams);
    for (const key of ORDER_FILTER_SEARCH_PARAMETERS) {
      delete existingParams[key];
    }

    const newParams = getOrdersTableFilterNewSearchParams(body);

    setSearchParams(
      createSearchParams({
        ...existingParams,
        ...newParams
      })
    );

    onClose();
  };

  return (
    <div className={styles.ordersTableFilter} ref={containerRef}>
      <Button
        variant={"primary"}
        icon={<FilterIcon />}
        className={styles.ordersTableFilter_button}
        onClick={onToggle}
      />

      <If condition={isOpen}>
        <div className={styles.ordersTableFilter_content}>
          <OrdersFilterForm
            formId={ORDERS_FILTER_FORM_ID}
            onSubmit={submitFilterForm}
            isLoading={isLoading}
            drivers={drivers}
            isDriversLoading={isDriversLoading}
            locations={locations}
            isLocationsLoading={isLocationsLoading}
          />
        </div>
      </If>
    </div>
  );
};

export default OrdersTableFilter;
